<div class="headers">
  <div class="info">
    <div class="nps-header">{{chartName}}</div>
    <div>Select a date to view hourly data</div>
  </div>
  <div class="filters">
    <select>
      <option selected disabled>Select</option>
      <option value="hourly">Hourly</option>
      <option value="daily">Daily</option>
      <option value="weekly">Weekly</option>
      <option value="monthly">Monthly</option>
      <option value="quarterly">Quarterly</option>
    </select>
    <div class="download">
      <img src="assets/images/download.svg" />
    </div>
    <div (click)="fullView()" class="zoom">
      <img src="assets/images/fullscreen.svg" />
    </div>
  </div>
</div>
<div class="chart-container">
  <canvas [id]="chartId" width="1800" height="428"></canvas>
</div>